<template>
  <div>
    <b-alert
        class="position-fixed fixed-top m-0 rounded-0 text-center"
        fade
        :show="dismissCountDown"
        :variant="errorMessage.color"
        @dismissed="dismissed"
      >{{ errorMessage.text }}</b-alert>
    <div class="teste d-none d-sm-block">
      <div class="teste2">
        <img src="@/assets/project_create_illo_welcome@2x.png" class="teste3" fluid />
      </div>
    </div>
    <header class="bg-light">
      <div class="container py-4">
        <h1 class>Crédito Imobiliário CAIXA</h1>
        <h6 class="lead">Crie sua proposta de forma rápida e descomplicada.</h6>
      </div>
    </header>
    <div class="container py-3">
      <div class="col-lg-6 lead">
        <blockquote class="blockquote" id="subTitle">
          <p class="mb-0">Vamos lá! ; )</p>
          <footer class="blockquote-footer">
            3 passos simples em apenas 5 minutos. !
            <i
              class="fas fa-question-circle"
              style="color:orange"
              data-toggle="popover"
              title="Proponente Principal"
              data-content="Se a proposta possui mais de um participante ao crédito, indique o que possui maior renda."
            ></i>
          </footer>
        </blockquote>
        <ol>
          <li style="font-size: smaller">Dados principais do(s) participante(s).</li>
          <li style="font-size: smaller">Dados da operação desejada.</li>
          <li style="font-size: smaller">Documentação da proposta.</li>
        </ol>
        <p style="font-size: smaller">
          <strong class="text-danger">PS.:</strong>
          <em>
            Antes de prosseguir tenha os documentos do
            <a href="#">checklist</a> dentro do prazo, digitalizados em JPG ou PDF e nítidos para envio.
          </em>
        </p>
        <b-form-checkbox style="font-size: smaller" v-model="termsAndConditions">
          Li e concordo com os
          <a href="#">termos e condições</a> do site.
        </b-form-checkbox>
        <b-button
          block
          class="mt-4"
          variant="primary"
          to="/participants"
          :disabled="!termsAndConditions"
        >Vamos lá!</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

var bootstrap = require("bootstrap");
var bootbox = require("bootbox");

export default {
  name: "Welcome",
  data() {
    return {
      termsAndConditions: false
    };
  },
  computed: {
    ...mapState([
      "preloader",
      "error",
      "errorMessage",
      "dismissCountDown"
    ]),
  },
  methods: {
    ...mapActions([
      "dismissed",
    ]),
  },
  watch: {
    termsAndConditions() {
      if (this.termsAndConditions) {
        bootbox.alert({
          message:
            "Olá! Passando para lembrar que o envio do extrato analítico é muito importante para nossa devidas conferências e enquadramento mesmo que o cliente não vá utilizar o FGTS ou que seja servidor público. ; )",
            /* "Olá! Passando para lembrar que o envio do extrato analítico é muito importante mesmo que o cliente não vá utilizar o FGTS ou que seja servidor público. Realizamos através dele a confirmação da renda, nº do PIS, comprovação dos 36 meses de contribuíção ao FGTS e data de admissão para um cadastro completo e enquadramento correto do cliente. ; )", */
          centerVertical: true,
          locale: "pt",
          buttons: {
            ok: {
              label: "Enviarei, pode deixar!"
            }
          }
        });
      } else {
        bootbox.alert({
          message:
            "Opss... Você desmarcou o aceite dos termos e condições. Para prosseguir é necessário aceitar os termos e condições do site. Qualquer dúvida conte-nos mais sobre enviando um e-mail para sac@parceirocaixa.com.br",
          centerVertical: true,
          locale: "pt",
          buttons: {
            ok: {
              label: "OK!"
            }
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.teste {
  background-attachment: scroll;
  background-color: #039be5;
  /* background-image: url(images/grain@2x.png); */
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 100% 100%;
  flex: 0 0 320px;
  height: 100%;
  /*min-height: 851px;*/
  position: absolute;
  position: fixed;
  right: 0;
  top: 0;
  width: 320px;
  z-index: 0;
}

.teste2 {
  /* height: 718px;*/
  pointer-events: none;
  position: absolute;
  position: fixed;
  right: 0px;
  /* top: 133px; */
  bottom: 0;
  width: 568px;
}

.teste3 {
  height: 80vh;
  position: absolute;
  width: 568px;
  bottom: 0;
  right: 10px;
  z-index: inherit;
}
</style>